/* eslint-disable */

import React, { useEffect, useState } from "react";
import styles from  "./css/Solution.module.css";
import { Box, Container, Grid, Stack, Typography } from "@mui/material";
import {ReactComponent as NoPassSvg} from '../img/ic_no_password.svg'
import {ReactComponent as MfaSvg} from '../img/ic_mfa_card.svg'
import {ReactComponent as InsightSvg} from '../img/ic_realtime_insight.svg'
import {ReactComponent as IcBulletSvg} from '../img/ic_bullet.svg'
import {ReactComponent as DeviceTrustSvg} from '../img/ic_device_trust_card.svg'
import {ReactComponent as WebswgSvg} from '../img/ic-web-protection.svg'
import {ReactComponent as VisitLinkSvg} from "../img/visit-link-arrow.svg"
import FeatureImg1 from "../img/webp/05-Feature Section/img_feature_1.webp"
import FeatureImg2 from "../img/webp/05-Feature Section/img_feature_2.webp"
import FeatureImg3 from "../img/webp/05-Feature Section/img_feature_3.webp"
import FeatureImg4 from "../img/webp/05-Feature Section/img_feature_4.webp"
import FeatureImg5 from "../img/webp/05-Feature Section/img_feature_5.webp"

const ContentAreaResponsive = ({list1, list2, title, BigImg}) => {
  return <Box sx={{padding: {sm:"48px 0 100px 48px", xs: "32px 32px 100px 32px"}, overflow: "hidden", minHeight: {sm: 392, xs: 472}, maxHeight: {sm: 425, xs: 586}, position: "relative", background: "linear-gradient(107deg, #0B3558 1.24%, #003FB9 50.74%, #07456A 98.99%)", borderRadius: "12px", width: "93%", margin: "0 auto 32px auto", height: "fit-content", display: {xs: "flex", lg: 'none'}}}>
  <Box flex={2} width={'max-content'} maxWidth={{xs: '100%', sm: "480px", lg: "100%"}}>
    <p className={styles.featureText}>{title}</p>
    <Stack flexDirection={'row'} alignItems={'center'} marginBottom={'13px'}>
    <Box style={{width: "fit-content"}}>
    <IcBulletSvg style={{width: "24px", height: "24px"}} />
    </Box>
    <Box width={'440px'}>
    <p className={styles.featureTextList}>{list1}</p>
    </Box>
    </Stack>
    <Stack flexDirection={'row'} alignItems={'center'} marginBottom={'48px'}>
    <Box style={{width: "fit-content"}}>
    <IcBulletSvg style={{width: "24px", height: "24px"}} />
    </Box>
    <Box width={'430px'}>
    <p className={styles.featureTextList}>{list2}</p>
    </Box>
    </Stack>
    <p className={styles.learnMore}>
  Learn More <VisitLinkSvg fill="#FFF" />
</p>

  </Box>
  <Box flex={1} position={'absolute'} bottom={0} right={0}>
  <Box component={'img'} src={BigImg} sx={{width: {xs: 130, sm: 200}}} className={styles.dotGrid}  />
  </Box>
  </Box>
}
const ContentArea = ({BigImg, list1, list2, title}) => {
  return <Box style={{position: 'absolute', top: 130, left: 150, width: '600px', display: "flex", alignItems: "start"}}>
  <Box sx={{flex: 2, width: "600px"}}>
    <p style={{width: "580px"}} className={styles.featureText}>{title}</p>
    <Stack flexDirection={'row'} alignItems={'center'} marginBottom={'13px'}>
    <IcBulletSvg style={{width: "24px", height: "24px"}} />
    <Box width={'100%'}>
    <p className={styles.featureTextList}>{list1}</p>
    </Box>
    </Stack>
    <Stack flexDirection={'row'} alignItems={'center'} marginBottom={'48px'}>
    <IcBulletSvg style={{width: "24px", height: "24px"}} />
    <Box width={'430px'}>
    <p className={styles.featureTextList}>{list2}</p>
    </Box>
    </Stack>
    <p className={styles.learnMore}>Learn More <VisitLinkSvg fill="#FFF"/></p>
  </Box>
  <Box>
  <Box component={'img'} src={BigImg} sx={{ position: 'absolute', flex: 1, width: 400, height: 400, transform: "translate(0px,-60px)"}} className={styles.dotGrid}  />
  </Box>
  </Box>
}

const CardBtn = ({selected, text, IconSvg, setSelected, containerMarginBottom, containerStyle}) => {
  return <>
    <Stack onMouseEnter={setSelected} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} marginBottom={containerMarginBottom && '16px'} width={'142px'} borderRadius='4px' style={{background: selected && 'linear-gradient(91deg, #0B3558 0.45%, #003FB9 99.51%)', padding: '8px', marginTop: "5px" , ...containerStyle}} height={'fit-content'}>
    <Box sx={{marginBottom: "0px"}}>
   <IconSvg fill={selected? '#FFF': "rgba(47, 94, 187, 1)"} style={{marginLeft: "auto", marginRight: "auto"}} />
  </Box>

  <p style={{color: selected? '#FFF': "#0B3558", fontWeight: selected? '600': '400'}} className={styles.cardBtnText}>{text || "Passwordless Authentication"}</p>
    </Stack>
  </>
}
function Solution() {
  const menuItems = ['password', 'mfa', 'device', 'insight']
  const [selected, setSelected] = useState('password')
  const [isHovered, setIsHovered] = useState(false);
  const switchMenuTime = 5000
  const getNextMenuItem = (current) => {
    const currentIndex = menuItems.indexOf(current);
    const nextIndex = (currentIndex + 1) % menuItems.length;
    return menuItems[nextIndex];
  };
  const contentObj = () => {
    switch (selected) {
      case 'password':
        return {list1: <>Replace passwords with a <span style={{fontWeight: "600"}}>secure PKI-based digital identity</span> to prevent account takeovers</>, list2: <><span style={{fontWeight: "600"}}>Validate 15+ MFA factors</span> like user behavior, device posture, and context to secure resources, including legacy and desktop apps</>, BigImg: FeatureImg1, title: 'Secure Every Access Point with Passwordless Authentication & Phishing-resistant MFA' }
      case 'mfa':
        return {list1: <><span style={{fontWeight: "600"}}>Prevent unauthorized access</span> to sensitive cloud-stored data</>, list2: <>Control data outflow from endpoints, <span style={{fontWeight: "600"}}>stopping leaks on managed and unmanaged devices</span></>, BigImg: FeatureImg2, title: 'Stop Data Leaks with Advanced Cloud and Endpoint Security' }
      case 'device':
        return {list1: <>Continuously <span style={{fontWeight: "600"}}>check device posture</span></>, list2: <><span style={{fontWeight: "600"}}>Block insecure and unauthorized devices </span>from accessing apps</>,  BigImg: FeatureImg3, title: 'Validate Trust on Each Device' }
      case 'swg':
          return {list1: <>Block access to high-risk websites and <span style={{fontWeight: "600"}}>protect against malware and other web-based threats</span></>, list2: <><span style={{fontWeight: "600"}}>Prevent data leaks</span> from unsanctioned applications</>, BigImg: FeatureImg4, title: 'Ensure Safe Browsing and Web Access Control with Secure Web Gateway' }
      case 'insight':
        return {list1: <><span style={{fontWeight: "600"}}>Get visibility</span> on application access and device compliance</>, list2: <>Improve response time drastically by <span style={{fontWeight: "600"}}>real-time detection of anomalies</span></>, BigImg: FeatureImg5, title: 'Stop Identity-based Threats in Real-time' }
    
      default:
        return {}
    }
  }
  const contentObjResponsive = (val) => {
    switch (val) {
      case 'password':
        return {list1: <><span style={{fontSize: "14px"}}>Replace passwords with a <span style={{fontWeight: "600", fontSize: "14px"}}>secure PKI-based digital identity</span> to prevent account takeovers</span></>, list2: <><span style={{fontWeight: "600", fontSize: "14px"}}>Validate 15+ MFA factors</span> like user behavior, device posture, and context to secure resources, including legacy and desktop apps</>, BigImg: FeatureImg1, title: 'Secure Every Access Point with Passwordless Authentication & Phishing-resistant MFA' }
      case 'mfa':
        return {list1: <><span style={{fontWeight: "600", fontSize: "14px"}}>Prevent unauthorized access</span> to sensitive cloud-stored data</>, list2: <><span style={{fontSize: "14px"}}>Control data outflow from endpoints, <span style={{fontWeight: "600", fontSize: "14px"}}>stopping leaks on managed and unmanaged devices</span></span></>, BigImg: FeatureImg2, title: 'Stop Data Leaks with Advanced Cloud and Endpoint Security' }
      case 'device':
        return {list1: <>Continuously <span style={{fontWeight: "600", fontSize: "14px"}}>check device posture</span></>, list2: <><span style={{fontWeight: "600", fontSize: "14px"}}>Block insecure and unauthorized devices </span>from accessing apps</>,  BigImg: FeatureImg3, title: 'Validate Trust on Each Device' }
      case 'swg':
        return {list1: <>Block access to high-risk websites and <span style={{fontWeight: "600", fontSize: "14px"}}>protect against malware and other web-based threats</span></>, list2: <><span style={{fontWeight: "600", fontSize: "14px"}}>Prevent data leaks</span> from unsanctioned applications</>, BigImg: FeatureImg4, title: 'Ensure Safe Browsing and Web Access Control with Secure Web Gateway' }
      case 'insight':
          return {list1: <><span style={{fontWeight: "600", fontSize: "14px"}}>Get visibility</span> on application access and device compliance</>, list2: <>Improve response time drastically by <span style={{fontWeight: "600", fontSize: "14px"}}>real-time detection of anomalies</span></>, BigImg: FeatureImg5, title: 'Stop Identity-based Threats in Real-time' }
    
      default:
        return {}
    }
  }
  useEffect(() => {
    const timer = setInterval(() => {
      if (!isHovered) {
        let data = getNextMenuItem(selected);
        setSelected(data);
      }
    }, switchMenuTime);

    return () => clearInterval(timer);
  }, [selected, isHovered]);
  return (
   <Box id="About" paddingTop={{sm: "80px", xs: "64px"}} paddingBottom={{lg: "80px", sm: '80px', xs: "64px"}}>
    <Typography variant="h1" sx={{fontWeight: '600', fontFamily :"Poppins", fontSize: {sm: "48px", xs: "20px"}, color: "#0B3558", textAlign: "center", paddingBottom: {sm: '80px', xs: "48px"}, paddingLeft: {xs: "16px", sm: "32px"}, paddingRight: {xs: "16px", sm: "32px"}}}>Introducing <Box component={'span'} sx={{fontSize: {sm: "48px", xs: "20px"}}} className={styles.themeText}>Identity-centric SSE Platform </Box></Typography>
    <Box onMouseLeave={() => setIsHovered(false)} onMouseEnter={() => setIsHovered(true)} sx={{display: {lg: 'block', xs: "none"}}} className={styles.bgBoard}>
    <Box marginTop={'-20px'} padding={'2px'} sx={{boxSizing: "border-box",border: "double 2px transparent" ,backgroundOrigin: "border-box",backgroundClip: "content-box, border-box",backgroundImage: "linear-gradient(white, white), linear-gradient(to bottom, rgba(56, 15, 56, 1), rgba(95, 168, 255, 1))", transform: "translateX(-74px)", borderRadius: "12px"}} display={{lg: 'flex', xs: "none"}} flexDirection={'column'} justifyContent={'space-evenly'} alignItems={'center'} minWidth={'166px'} maxWidth={'fit-content'} maxHeight={'fit-content'} minHeight={'528px'}>
      <CardBtn containerStyle={{marginTop: "10px"}} IconSvg={(props) => <NoPassSvg {...props} />} text={'Phishing-resistant'} setSelected={() => setSelected('password')} selected={selected === 'password'? true: false}  />
      <CardBtn IconSvg={(props) => <MfaSvg {...props} />} text={<>Data <br/> Protection</>} setSelected={() => setSelected('mfa')} selected={selected === 'mfa'? true: false} />
      <CardBtn IconSvg={(props) => <DeviceTrustSvg {...props} />} text={<>Device <br/> Trust</>} setSelected={() => setSelected('device')} selected={selected === 'device'? true: false} />
      <CardBtn IconSvg={(props) => <WebswgSvg {...props} />} text={<>Web <br/> Security</>} setSelected={() => setSelected('swg')} selected={selected === 'swg'? true: false} containerMarginBottom={0}/>
      <CardBtn containerStyle={{marginBottom: "10px"}} IconSvg={(props) => <InsightSvg {...props} />} text={<>Real-time <br/> Insights</>} setSelected={() => setSelected('insight')} selected={selected === 'insight'? true: false} containerMarginBottom={0}/>
    </Box>
    <ContentArea {...contentObj()} />
    </Box>
    <ContentAreaResponsive {...contentObjResponsive('password')} />
    <ContentAreaResponsive {...contentObjResponsive('mfa')} />
    <ContentAreaResponsive {...contentObjResponsive('device')} />
    <ContentAreaResponsive {...contentObjResponsive('swg')} />
    <ContentAreaResponsive {...contentObjResponsive('insight')} />


   </Box>
  );
}
export default Solution;
